import { stringEnum } from 'common/utils/objects';

export const TimeUnits = stringEnum(['hours', 'days', 'weeks']);
export type TimeUnit = keyof typeof TimeUnits;
export const timeUnitValues = Object.values(TimeUnits);
